<template>
  <div class="home">
    <van-nav-bar
      title="买就送"
      left-text="返回"
      left-arrow
      fixed
      @click-left="onClickLeft"
    />
  
       

  </div>
</template>
<script>
import Vue from 'vue'

import { NavBar, AddressList, Toast,Swipe, SwipeItem, Lazyload,CountDown,Progress } from 'vant'

Vue.use(NavBar).use(AddressList).use(Toast).use(Swipe)
  .use(SwipeItem)
  .use(Lazyload, { lazyComponent: true }).use(CountDown).use(Progress);
export default {
  created () {
  //  this.axios.get('listGoodsByCateBrand', { params: { store_id:this.$store.state.shopid, class_id: this.$route.query.id, class_name:'货空间'} }).then(res => {
  //         // console.log(res)
  //         this.list=res.data.data
  //       }).catch(ref => { })
   
  },
  destroyed(){
   

  },
  data () {
    return {
      chosenAddressId: '1',
       time: 3000,
     list:[],
     specs_show:false,
    sid:'',
    pname:'',
    oid:[],
    ptimg:[],
    };
  },
  methods: {
   
   
    onClickLeft () {
      this.$router.go(-1)
    },
   go(id,le){
 
    this.$router.push({ name: 'bingp', query: { id,le} })

   
   },
   go1(io,le){
  
    if(this.$store.state.shopid==1){
               this.$router.push({ name: 'bingp', query: { id:4664,le} })

    }
     if(this.$store.state.shopid==51){
               this.$router.push({ name: 'bingp', query: { id:4665,le} })

    }
    if(this.$store.state.shopid==3){
               this.$router.push({ name: 'bingp', query: { id:4666,le} })

    }
   },
   go2(io,le){
   
    if(this.$store.state.shopid==1){
          this.$router.push({ name: 'bingp', query: { id:4667,le} })

    }
    if(this.$store.state.shopid==51){
               this.$router.push({ name: 'bingp', query: { id:4669,le} })

    }
     if(this.$store.state.shopid==3){
               this.$router.push({ name: 'bingp', query: { id:4668,le} })

    }
   },
   goa(id){
    Toast('龙骨具体优惠请联系业务员咨询~')
   }
    
    
  },
  components: {
 
    // One
  },
}
</script>
<style lang="less" scoped>
.home{
      background-color: #640fb2;
height: 100%;
padding-top: 0.9rem;

}
.goods{
height: 100%;
      background-color: #640fb2;

  .gn{
  background-color: #fff;
  height: 21rem;
  border-radius: 0.5rem;
  padding: 0.2rem;
  img{
    margin-top: 0.2rem;
  }

  }
  padding: 0.2rem;
  .w{
    width: 60%;
    text-align: center;
    margin: 0 auto;
padding-bottom: 0.35rem;
  }
}


</style>